<script>
import { showModal } from "@app/store/modalStore.svelte.js";
import { cliConfigState } from "@app/store/cliConfigStore.svelte.js";
import Menu from "../menu/Menu.svelte";
import MenuItem from "../menu/MenuItem.svelte";
import * as m from "@app/paraglide/messages.js";

let hasEnabledTools = $derived(
    cliConfigState.filter((cliTool) => cliTool.options[0].selected === "true")
        .length > 0,
);
</script>

{#if hasEnabledTools}
    <Menu id="cli" label={m.cli_tools()} ariaLabel={m.cli_tools_menu()}>
        {#each cliConfigState as cliType (cliType.name)}
            <MenuItem
                label={cliType.name}
                icon="bi-terminal"
                id={"cli" + cliType.name.replace(/\s+/g, "")}
                onSelect={() => showModal(cliType.modalName)} />
        {/each}
    </Menu>
{/if}
